import { KaziLayout } from '../../Shared Components/Kazi/Layouts/KaziLayout'
import { ViewPosting } from './Components/ViewPosting'

export const ClientJobPostings = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziLayout>
            <ViewPosting />
        </KaziLayout>
    )
}